import React from "react";
import LogNav from "../layout/LoggedNav";

import Hole from "../Holes/Holes";
import HoleDetail from "../Holes/HoleDetail";
import { Route, Switch } from "react-router-dom";
import CourseMapsDetails from "../layout/courses/CourseMapsDetails";
import { CoursesProvider } from "../layout/courses/CourseProvider";
import AddCourses from "../layout/courses/AddedCoursesCard";
import { getAuthData } from "../../services/authService";
const auth = getAuthData();

const CoursesMapping = (props) => {
  return (
    <>
      <section className=" club_Login">
        <div className="page-width">
          <div className="c-mapping-data gap-block-section">
            <h1 className="c-mapping--title text-jost-sb-50">
            </h1>
            <LogNav />
            <div className="c-mapping__wrap">
              <AddCourses {...props} />

              <Switch>
                <Route path="/courses-map-courses/hole" component={Hole} />
                <Route
                  path="/courses-map-courses/hole-detail"
                  component={HoleDetail}
                />
                <Route
                  exact
                  path="/courses-map-courses"
                  component={CourseMapsDetails}
                />
              </Switch>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default (props) => (
  <CoursesProvider>
    <CoursesMapping {...props} />
  </CoursesProvider>
);
